import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getActivity = createAsyncThunk(
  "admin/activity",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/activity", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getActivityById = createAsyncThunk(
  "admin/activity/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/activity/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortActivity = createAsyncThunk(
  "admin/activity/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/activity/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postActivity = createAsyncThunk(
  "admin/activity/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/activity", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "admin/activity/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/activity/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateActivity = createAsyncThunk(
  "admin/activity/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/activity/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const activitySlice = createSlice({
  name: "Activity Store",
  initialState: initialState,
  reducers: {
    addActivity(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortActivity(state, action) {
      state.data.docs = action.payload;
    },
    deleteActivity(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editActivity(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getActivity.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getActivityById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getActivityById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getActivityById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortActivity.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postActivity.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postActivity.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteActivity.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteActivity.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateActivity.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateActivity.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const activityActions = activitySlice.actions;

export default activitySlice.reducer;
